import Model from './model.js';
import Address from './address.js';
import Employees from 'newCollections/employees.js';

export default class CompanyLocation extends Model {
    urlRoot() { return '/CompanyLocations'; }

    defaults() {
        return {
            name: 'HQ',
            addressId: null,
            primary: true
        };
    }

    constraints() {
        return {
            name: {presence: {message: '^Name is required'}},
            companyId: {presence: true},
            primary: {presence: true}
        };
    }

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    initialize() {
        this.idAttribute = 'objectId';
        super.initialize(...arguments);

        if (!this.get('addressId')) {
            this.setAddress(new Address(null, {
                validate: false,
                companyLocation: this
            }));
        }
        this.employees = new Employees(null, {
            companyLocation: this,
            pagination: false
        });

        return this;
    }

    save() {
        if (this.getAddress() && this.getAddress().dirty()) {
            let options = {};

            // if address is not primary, validate only state
            if (!this.get('primary')) {
                options = {validateAttrs: {include: ['state']}};
            }

            return this.getAddress().save(null, options)
                .then(() => this.set(
                    {addressId: this.getAddress().id},
                    {validate: false}
                ))
                .then(() => super.save(...arguments));
        }

        return super.save(...arguments);
    }

    fetchAddress() {
        if (!this.get('addressId')) {
            return this.address;
        }

        return new Address(
            {objectId: this.get('addressId')},
            {validate: false, companyLocation: this}
        ).fetch({validate: false}).then(model => {
            this.setAddress(model);
            return model;
        });
    }

    getAddress() {
        return this.address;
    }

    setAddress(address) {
        const old = this.getAddress();

        if (old) {
            old.off('change', null, null);
        }

        this.address = address;
        this.address.companyLocation = this;
        this.address.on('change', (model, options) => {
            // Some views check the changed attribute of a model to determine
            // whether we need to toggle an error message or not.
            // So we extend `changed` with whatever changed in the address
            // so the views can see it
            this.changed = Object.assign(
                this.changed || {}, model.changed || {}
            );

            Object.keys(model.changed).forEach(attr => {
                if (this.validationError && this.validationError[attr]) {
                    delete this.validationError[attr];
                }
            });
            this.trigger('change', this, options);
        });
        this.address.on('invalid', (model, error, options) => {
            this.validationError = Object.assign(
                {},
                this.validationError || {},
                this.address.validationError || {}
            );
            this.trigger('invalid', this, error, options);
        });
    }

    fetchEmployees() {
        return this.employees.fetch({filter: {limit: 9999}});
    }

    getEmployees() {
        return this.employees;
    }

    validate(attrs, options) {
        const locationResult = super.validate(...arguments);
        const address = this.getAddress();
        let finalResult = locationResult;

        if (address) {
            const addressResult = this.getAddress().validate(
                this.getAddress().attributes, options
            );

            if (addressResult) {
                finalResult = Object.assign(
                    {},
                    locationResult || {},
                    addressResult
                );
            }
        }

        return finalResult;
    }

    dirty() {
        let dirty = super.dirty();

        if (this.getAddress()) {
            dirty = dirty || this.getAddress().dirty();
        }

        return dirty;
    }

    // TODO deprecate
    getValidationError() {
        return this.validationError;
    }
}



// WEBPACK FOOTER //
// ./app/new-models/company-location.js